export enum TriggerTypes {
  Ability,
  Movement,
  ProximityLocation,
  EntryExit,
}
